import type { AudioHook } from "@spacecrew/shared";

/** [frequency Hz, duration ms, waveform]. Exhaustive by type: a hook without a placeholder fails `pnpm check`. */
export type Tone = readonly [hz: number, ms: number, wave: OscillatorType, hz2?: number];

export const TONES: Record<AudioHook, Tone> = {
  "ui.boot":             [440, 180, "sine", 880],
  "ui.denied":           [140, 160, "square", 110],
  "crew.join":           [523, 120, "triangle", 784],
  "crew.leave":          [784, 120, "triangle", 523],
  "crew.link.lost":      [220, 260, "sawtooth", 90],
  "crew.link.restored":  [330, 140, "sine", 660],
  "mission.start":       [392, 420, "square", 784],
  "mission.won":         [523, 700, "triangle", 1046],
  "mission.lost":        [196, 1400, "sawtooth", 49],
  "move.depart":         [900, 40, "square"],
  "move.arrive":         [600, 50, "square"],
  "move.footsteps.loop": [180, 0, "square"],
  "reactor.hum.loop":    [55, 0, "sine"],
  "reactor.low":         [660, 320, "square", 440],
  "reactor.critical":    [880, 420, "square", 880],
  "reactor.scram":       [300, 1200, "sawtooth", 30],
  "breaker.trip":        [120, 220, "sawtooth", 60],
  "breaker.flip":        [1200, 35, "square"],
  "breaker.wrong":       [160, 300, "square", 120],
  "breaker.reset":       [700, 140, "triangle", 1050],
  "breaker.unlock":      [1000, 40, "sine"],
  "hold.press":          [90, 90, "sawtooth"],
  "hold.release":        [400, 60, "square"],
  "hold.waiting":        [520, 90, "sine"],
  "hold.engaged":        [200, 300, "sawtooth", 600],
  "hold.engaged.loop":   [220, 0, "sawtooth"],
  "hold.success":        [660, 500, "triangle", 1320],
  "hold.fail":           [330, 500, "sawtooth", 80],
  "hold.ready":          [988, 100, "sine"],
  "intercom.open":       [600, 140, "sine", 1200],
  "intercom.mute":       [180, 60, "square"],
  "intercom.unmute":     [360, 60, "square"],
  "intercom.peer.link":  [700, 120, "triangle", 1050],
  "intercom.peer.lost":  [300, 260, "sawtooth", 80],
  "power.set":           [1400, 30, "square"],
  "power.brownout":      [240, 420, "sawtooth", 90],
  "o2.low":              [740, 300, "triangle", 560],
  "o2.critical":         [740, 220, "triangle", 560],
  "o2.restored":         [480, 160, "sine", 720],
  "coolant.leak":        [3000, 500, "sawtooth", 900],
  "coolant.sealed":      [180, 220, "square", 420],
  "coolant.backflow":    [260, 400, "sawtooth", 120],
  "relay.damaged":       [1800, 260, "sawtooth", 60],
  "relay.taken":         [600, 70, "square"],
  "relay.socketed":      [900, 120, "triangle", 1500],
  "director.calm":       [0, 0, "sine"],
  "ship.idle.loop":      [0, 0, "sine"],  // sample-backed: /audio/ship-idle.ogg
  "drill.start":         [520, 260, "square", 660],
  "drill.complete":      [200, 120, "square", 150],
  "fixture.switch":      [1400, 35, "square", 700],
  "fixture.button":      [900, 28, "square", 620],
  "fixture.lever":       [260, 130, "sawtooth", 150],
  "fixture.dial":        [1800, 18, "square"],
  "fixture.drawer":      [180, 220, "sawtooth", 120],
  "fixture.stuck":       [110, 90, "square", 90],
};
